import React from 'react';
import { Alert, Box, Chip, Typography } from '@mui/material';
import { AutoFixHigh as HealIcon } from '@mui/icons-material';
import { NLHealingInfo } from '../types';

interface NLHealingIndicatorProps {
  healing: NLHealingInfo;
}

const NLHealingIndicator: React.FC<NLHealingIndicatorProps> = ({ healing }) => {
  const confidencePct = Math.round(healing.confidence * 100);

  return (
    <Alert
      severity="info"
      icon={<HealIcon fontSize="small" />}
      sx={{ py: 0.5, px: 1.5, my: 0.5, '& .MuiAlert-message': { width: '100%' } }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Typography variant="caption" fontWeight={600}>
          Self-healed:
        </Typography>
        <Typography
          variant="caption"
          sx={{ fontFamily: 'monospace', textDecoration: 'line-through', color: 'text.secondary' }}
        >
          {healing.old_selector}
        </Typography>
        <Typography variant="caption">→</Typography>
        <Typography variant="caption" sx={{ fontFamily: 'monospace', fontWeight: 600 }}>
          {healing.new_selector}
        </Typography>
        <Chip
          size="small"
          label={`${confidencePct}%`}
          color={confidencePct >= 90 ? 'success' : confidencePct >= 70 ? 'warning' : 'error'}
          sx={{ height: 18, fontSize: '0.7rem' }}
        />
        {healing.strategy_used && (
          <Chip
            size="small"
            label={healing.strategy_used}
            variant="outlined"
            sx={{ height: 18, fontSize: '0.7rem' }}
          />
        )}
      </Box>
    </Alert>
  );
};

export default NLHealingIndicator;
